// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const FolderIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="M20.61 7.07c-1.14-1.23-2.59-1.2-3.87-1.17-.8.01-1.56.03-2.1-.28-.67-.39-.9-.82-1.18-1.32-.3-.55-.63-1.18-1.54-1.68-1.7-.9-3.68-1.08-6.24-.55-2.54.51-4.18 2.76-4.18 5.72v6.3c0 7.56 4.35 8.14 10.5 8.14 5.95 0 10.5-.6 10.5-8.16 0-1.86 0-4.96-1.89-7"
        clipRule="evenodd"
        opacity=".5"
      />
      <path d="M7.01 15.61h9.96c.43 0 .78-.35.78-.78s-.35-.78-.78-.78H7.01c-.43 0-.78.35-.78.78s.35.78.78.78" />
    </g>
  </SvgIcon>
);

export default FolderIcon;
